import { render } from "./property-nearbyhouse.vue?vue&type=template&id=7d1471e4"
import script from "./property-nearbyhouse.js?vue&type=script&lang=js"
export * from "./property-nearbyhouse.js?vue&type=script&lang=js"

import "./property-nearbyhouse.vue?vue&type=style&index=0&id=7d1471e4&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__